import { KnowledgeScopeSelection } from '../ThreadsPage/KnowledgeScopePicker'

/**
 * The scope "Continue in new thread" stores: this thread's own sources and its
 * Topic focus, so the new thread does not widen back to the whole library or
 * lose the Topic.
 */
export function continueThreadScope(scope: KnowledgeScopeSelection) {
  return {
    sourceMode: scope.sourceMode ?? 'auto',
    ...(scope.sourceKinds ? { sourceKinds: scope.sourceKinds } : {}),
    ...(scope.socialWindow ? { socialWindow: scope.socialWindow } : {}),
    ...(scope.socialFocus ? { socialFocus: scope.socialFocus } : {}),
    web: scope.web !== false,
    library: scope.library !== false,
    mode: scope.mode,
    documentTokens: scope.documentTokens,
    collectionTokens: scope.collectionTokens,
    ...(scope.libraryCollectionTokens?.length
      ? { libraryCollectionTokens: scope.libraryCollectionTokens }
      : {}),
  }
}
